module.exports = __webpack_public_path__ + "static/media/Brazilian_JournalBiology.d488e5cb.png";